<app-progress-bar-request></app-progress-bar-request>
<mat-sidenav-container
    (window:resize)="onResize()"
    [ngClass]="{ 'sidebar-collapsed': isCollapsed }"
>
    <mat-sidenav
        *ngIf="showSidebar"
        mode="{{ mode }}"
        [(opened)]="opened"
        [ngClass]="{ collapsed: isCollapsed }"
    >
        <ng-container *ngIf="!useAiSidebar; else aiSidebar">
            <div class="navigation">
                <mat-icon
                    *ngIf="closeIcon"
                    (click)="opened = false"
                    class="close-icon"
                    >close</mat-icon
                >
                <div
                    class="logo-wrapper !gap-0 !px-[16px] !py-[16px] flex !items-center"
                >
                    <div class="logo-text" routerLink="/components/assignments">
                        <div class="flex items-center gap-[12px]">
                            <div
                                class="flex items-center justify-center w-[40px] h-[40px] !bg-primary rounded-lg shadow-sm"
                            >
                                <img
                                    src="/assets/img/safetly_logo_re.png"
                                    loading="lazy"
                                    alt="Company logo"
                                    class="h-[26px] w-[24px] rounded-sm object-cover"
                                />
                            </div>
                            <div class="flex flex-col" *ngIf="!isCollapsed">
                                <div
                                    class="text-[14px] font-bold text-sidebar-foreground leading-none"
                                >
                                    {{ "safetly" | translate }}
                                </div>
                                <div
                                    class="text-[12px] text-muted-foreground mt-[2px]"
                                >
                                    {{
                                        "security-management-platform"
                                            | translate
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!closeIcon" class="flex gap-2">
                        <button
                            class="menu-button p-0"
                            (click)="toggleSidebar()"
                            [class.rotate-180]="isCollapsed"
                            aria-label="Toggle Collapse"
                        >
                            <img
                                src="../../assets/svg/sidebar.svg"
                                alt="sidebar"
                                loading="lazy"
                            />
                        </button>
                    </div>
                </div>
                <div class="flex-grow-1" style="overflow: hidden">
                    <div
                        class="flex-1 overflow-y-auto py-[12px] space-y-[16px] max-h-[76vh]"
                    >
                        <div class="flex-1 space-y-[16px]">
                            <!-- Unauthenticated: show Login in sidebar -->
                            <div *ngIf="!customer" class="px-[16px] py-[12px]">
                                <a
                                    routerLink="/login"
                                    class="inline-flex items-center gap-2 w-full justify-center bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 text-white font-medium py-3 px-4 rounded-xl transition-all duration-300 hover:scale-[1.02] hover:shadow-lg"
                                >
                                    <span>{{
                                        "buttons.login" | translate
                                    }}</span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    >
                                        <path d="M5 12h14"></path>
                                        <path d="m12 5 7 7-7 7"></path>
                                    </svg>
                                </a>
                            </div>
                            <!-- Verksamhet -->
                            <div
                                class="animate-fade-in !text-gray-900"
                                style="animation-delay: 0ms"
                                *ngIf="customer"
                            >
                                <div
                                    class="relative flex w-full min-w-0 flex-col px-[8px] py-[8px]"
                                >
                                    <div
                                        *ngIf="!isCollapsed"
                                        class="duration-200 flex h-[32px] shrink-0 items-center !rounded-[6px] outline-none ring-sidebar-ring text-[11px] font-bold text-muted-foreground uppercase tracking-widest mb-[12px] px-[4px] opacity-70"
                                    >
                                        {{
                                            "navigation.main-feature"
                                                | translate
                                        }}
                                    </div>
                                    <div class="w-full text-sm">
                                        <ul
                                            class="flex w-full min-w-0 flex-col gap-[4px] space-y-[6px] !p-0"
                                        >
                                            <!-- assignments -->
                                            <li
                                                class="group/menu-item relative animate-fade-in"
                                                style="animation-delay: 0ms"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true,
                                                }"
                                            >
                                                <a
                                                    routerLink="/components/assignments"
                                                    [ngClass]="
                                                        router.url.includes(
                                                            'assignments'
                                                        )
                                                            ? [
                                                                  'transform',
                                                                  'scale-[1.02]',
                                                                  'bg-gradient-to-r',
                                                                  'from-blue-600',
                                                                  'to-blue-500',
                                                                  '!text-white',
                                                                  'ring-2',
                                                                  'ring-blue-400/30',
                                                                  'shadow-lg',
                                                              ]
                                                            : [
                                                                  'hover:bg-gradient-to-r',
                                                                  'hover:from-blue-50',
                                                                  'hover:to-blue-50/50',
                                                                  'hover:!text-blue-700',
                                                                  'hover:shadow-md',
                                                                  'hover:scale-[1.01]',
                                                                  'hover:translate-x-[4px]',
                                                              ]
                                                    "
                                                    class="peer/menu-button group flex w-full items-center gap-[12px] px-[16px] py-[14px] rounded-xl text-sm font-medium transition-all duration-300 min-h-[48px] relative overflow-hidden text-sidebar-foreground !text-gray-900"
                                                >
                                                    <div
                                                        class="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent opacity-50"
                                                    ></div>

                                                    <div
                                                        class="flex items-center justify-center w-[24px] h-[24px] rounded-lg transition-all duration-300 relative z-10"
                                                        [matTooltip]="
                                                            isCollapsed
                                                                ? ('navigation.overview'
                                                                  | translate)
                                                                : ''
                                                        "
                                                        matTooltipPosition="right"
                                                        [ngClass]="
                                                            router.url.includes(
                                                                'assignments'
                                                            )
                                                                ? [
                                                                      'text-white',
                                                                      'bg-white/20',
                                                                  ]
                                                                : [
                                                                      'text-muted-foreground',
                                                                      'group-hover:text-blue-700',
                                                                      'group-hover:bg-blue-100',
                                                                      'group-hover:scale-110',
                                                                  ]
                                                        "
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            stroke-width="2"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            class="lucide lucide-calendar w-4 h-4"
                                                        >
                                                            <path
                                                                d="M8 2v4"
                                                            ></path>
                                                            <path
                                                                d="M16 2v4"
                                                            ></path>
                                                            <rect
                                                                width="18"
                                                                height="18"
                                                                x="3"
                                                                y="4"
                                                                rx="2"
                                                            ></rect>
                                                            <path
                                                                d="M3 10h18"
                                                            ></path>
                                                        </svg>
                                                    </div>

                                                    <span
                                                        *ngIf="!isCollapsed"
                                                        class="flex-1 text-left leading-tight relative z-10 font-medium"
                                                        [ngClass]="
                                                            router.url.includes(
                                                                'assignments'
                                                            )
                                                                ? ['text-white']
                                                                : [
                                                                      'text-gray-900',
                                                                  ]
                                                        "
                                                    >
                                                        {{
                                                            "navigation.overview"
                                                                | translate
                                                        }}
                                                    </span>

                                                    <!-- <div *ngIf="!isCollapsed && assignmentsStatistics?.ongoingAssignmentsCount !== null"
                                                    class="inline-flex items-center justify-center min-w-[24px] h-[24px] px-[8px] rounded-full text-[13px] font-bold transition-all duration-300 shadow-md relative z-10 animate-pulse"
                                                    [ngClass]="router.url.includes('assignments') ? ['bg-white', 'text-blue-600', 'shadow-lg', 'scale-110'] : ['bg-gradient-to-r', 'from-blue-600', 'to-blue-500', 'text-white']">
                                                    {{assignmentsStatistics?.ongoingAssignmentsCount}}
                                                </div> -->

                                                    <div
                                                        class="absolute inset-0 bg-gradient-to-r from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                                    ></div>
                                                </a>
                                            </li>

                                            <!-- Dynamisk bevakning & Utryckning -->
                                            <li
                                                class="group/menu-item relative animate-fade-in"
                                                style="animation-delay: 50ms"
                                                [class.disabled-link]="true"
                                                [class.active]="
                                                    dynamicMonitoring == true ||
                                                    router.url.includes(
                                                        'dynamic-monitoring'
                                                    )
                                                "
                                                (click)="
                                                    onDynamicMonitoringClicked()
                                                "
                                            >
                                                <a
                                                    routerLink="/components/assignments"
                                                    routerLinkActive="active"
                                                    [ngClass]="
                                                        dynamicMonitoring ===
                                                            true ||
                                                        router.url.includes(
                                                            'dynamicMonitoring'
                                                        )
                                                            ? [
                                                                  'transform',
                                                                  'scale-[1.02]',
                                                                  'bg-gradient-to-r',
                                                                  'from-blue-600',
                                                                  'to-blue-500',
                                                                  '!text-white',
                                                                  'ring-2',
                                                                  'ring-blue-400/30',
                                                                  'shadow-lg',
                                                              ]
                                                            : [
                                                                  'hover:bg-gradient-to-r',
                                                                  'hover:from-blue-50',
                                                                  'hover:to-blue-50/50',
                                                                  'hover:!text-blue-700',
                                                                  'hover:shadow-md',
                                                                  'hover:scale-[1.01]',
                                                                  'hover:translate-x-[4px]',
                                                              ]
                                                    "
                                                    class="peer/menu-button group flex w-full items-center gap-[12px] px-[16px] py-[14px] rounded-xl text-sm font-medium transition-all duration-300 min-h-[48px] relative overflow-hidden text-sidebar-foreground !text-gray-900"
                                                >
                                                    <div
                                                        class="flex items-center justify-center w-[24px] h-[24px] rounded-lg transition-all duration-300 relative z-10"
                                                        [matTooltip]="
                                                            isCollapsed
                                                                ? ('navigation.surveillance-tracking'
                                                                  | translate)
                                                                : ''
                                                        "
                                                        matTooltipPosition="right"
                                                        [ngClass]="
                                                            dynamicMonitoring ===
                                                                true ||
                                                            router.url.includes(
                                                                'dynamicMonitoring'
                                                            )
                                                                ? [
                                                                      'text-white',
                                                                      'bg-white/20',
                                                                  ]
                                                                : [
                                                                      'text-muted-foreground',
                                                                      'group-hover:text-blue-700',
                                                                      'group-hover:bg-blue-100',
                                                                      'group-hover:scale-110',
                                                                  ]
                                                        "
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            stroke-width="2"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            class="lucide lucide-eye w-4 h-4"
                                                        >
                                                            <path
                                                                d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"
                                                            ></path>
                                                            <circle
                                                                cx="12"
                                                                cy="12"
                                                                r="3"
                                                            ></circle>
                                                        </svg>
                                                    </div>
                                                    <span
                                                        *ngIf="!isCollapsed"
                                                        class="flex-1 text-left leading-tight relative z-10 font-medium"
                                                        [ngClass]="
                                                            dynamicMonitoring ===
                                                                true ||
                                                            router.url.includes(
                                                                'dynamicMonitoring'
                                                            )
                                                                ? ['text-white']
                                                                : [
                                                                      'text-gray-900',
                                                                  ]
                                                        "
                                                    >
                                                        {{
                                                            "navigation.surveillance-tracking"
                                                                | translate
                                                        }}
                                                    </span>
                                                    <!-- <span *ngIf="!isCollapsed"
                                                    class="bg-blue-100 text-blue-700 px-2 py-1.0 rounded">
                                                    Coming Soon
                                                </span> -->

                                                    <div
                                                        *ngIf="!isCollapsed"
                                                        class="text-[11px] font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded-full"
                                                    >
                                                        {{
                                                            "profile.coming-soon"
                                                                | translate
                                                        }}
                                                    </div>

                                                    <div
                                                        class="absolute inset-0 bg-gradient-to-r from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                                    ></div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <!-- Administration -->
                            <div
                                class="animate-fade-in !text-gray-900 -mt-6 border-t border-[rgb(229,231,235)]"
                                style="animation-delay: 100ms"
                                *ngIf="customer"
                            >
                                <div
                                    class="relative flex w-full min-w-0 flex-col px-[8px] py-[8px]"
                                >
                                    <div
                                        *ngIf="!isCollapsed"
                                        class="duration-200 flex h-[32px] shrink-0 items-center !rounded-[6px] outline-none ring-sidebar-ring text-[11px] font-bold text-muted-foreground uppercase tracking-widest mb-[12px] px-[4px] opacity-70"
                                    >
                                        {{
                                            "navigation.administration"
                                                | translate
                                        }}
                                    </div>
                                    <div
                                        class="w-full text-sm"
                                        *ngIf="customer"
                                    >
                                        <ul
                                            class="flex w-full min-w-0 flex-col gap-[4px] space-y-[6px] !p-0"
                                        >
                                            <!-- reports details menu -->
                                            <li
                                                class="group/menu-item relative animate-fade-in"
                                                (click)="onReportsClicked()"
                                                style="animation-delay: 0ms"
                                                [class.active]="
                                                    reports == true ||
                                                    router.url.includes(
                                                        'reports'
                                                    )
                                                "
                                                [class.disabled-link]="true"
                                            >
                                                <a
                                                    routerLink="/components/reports/reports-details"
                                                    routerLinkActive="active"
                                                    [ngClass]="
                                                        reports === true ||
                                                        router.url.includes(
                                                            'reports'
                                                        )
                                                            ? [
                                                                  'transform',
                                                                  'scale-[1.02]',
                                                                  'bg-gradient-to-r',
                                                                  'from-blue-600',
                                                                  'to-blue-500',
                                                                  '!text-white',
                                                                  'ring-2',
                                                                  'ring-blue-400/30',
                                                                  'shadow-lg',
                                                              ]
                                                            : [
                                                                  'hover:bg-gradient-to-r',
                                                                  'hover:from-blue-50',
                                                                  'hover:to-blue-50/50',
                                                                  'hover:!text-blue-700',
                                                                  'hover:shadow-md',
                                                                  'hover:scale-[1.01]',
                                                                  'hover:translate-x-[4px]',
                                                              ]
                                                    "
                                                    class="peer/menu-button group flex w-full items-center gap-[12px] px-[16px] py-[14px] rounded-xl text-sm font-medium transition-all duration-300 min-h-[48px] relative overflow-hidden text-sidebar-foreground !text-gray-900"
                                                >
                                                    <div
                                                        class="flex items-center justify-center w-[24px] h-[24px] rounded-lg transition-all duration-300 relative z-10"
                                                        [matTooltip]="
                                                            isCollapsed
                                                                ? ('navigation.reports'
                                                                  | translate)
                                                                : ''
                                                        "
                                                        matTooltipPosition="right"
                                                        [ngClass]="
                                                            reports === true ||
                                                            router.url.includes(
                                                                'reports'
                                                            )
                                                                ? [
                                                                      'text-white',
                                                                      'bg-white/20',
                                                                  ]
                                                                : [
                                                                      'text-muted-foreground',
                                                                      'group-hover:text-blue-700',
                                                                      'group-hover:bg-blue-100',
                                                                      'group-hover:scale-110',
                                                                  ]
                                                        "
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            stroke-width="2"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            class="lucide lucide-file-text w-4 h-4"
                                                        >
                                                            <path
                                                                d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                                                            ></path>
                                                            <path
                                                                d="M14 2v4a2 2 0 0 0 2 2h4"
                                                            ></path>
                                                            <path
                                                                d="M10 9H8"
                                                            ></path>
                                                            <path
                                                                d="M16 13H8"
                                                            ></path>
                                                            <path
                                                                d="M16 17H8"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <span
                                                        *ngIf="!isCollapsed"
                                                        class="flex-1 text-left leading-tight relative z-10 font-medium"
                                                        [ngClass]="
                                                            reports === true ||
                                                            router.url.includes(
                                                                'reports'
                                                            )
                                                                ? ['text-white']
                                                                : [
                                                                      'text-gray-900',
                                                                  ]
                                                        "
                                                    >
                                                        {{
                                                            "navigation.reports"
                                                                | translate
                                                        }}
                                                    </span>
                                                    <!-- <span *ngIf="!isCollapsed"
                                                    class="bg-blue-100 text-blue-700 px-2 py-1.0 rounded">
                                                    Coming Soon
                                                </span> -->
                                                    <div
                                                        *ngIf="!isCollapsed"
                                                        class="text-[11px] font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded-full"
                                                    >
                                                        {{
                                                            "profile.coming-soon"
                                                                | translate
                                                        }}
                                                    </div>
                                                    <!-- <div *ngIf="!isCollapsed"
                                                    class="inline-flex items-center justify-center min-w-[24px] h-[24px] px-[8px] rounded-full text-[11px] font-bold transition-all duration-300 shadow-md relative z-10 animate-pulse bg-white text-blue-600 shadow-lg scale-110"
                                                    [ngClass]="(reports === true || router.url.includes('reports')) ? ['bg-white', 'text-blue-600', 'shadow-lg', 'scale-110'] : ['animate-pulse', 'bg-gradient-to-r', 'from-blue-600', 'to-blue-500', 'text-white']">
                                                    5
                                                </div> -->
                                                    <div
                                                        class="absolute inset-0 bg-gradient-to-r from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                                    ></div>
                                                </a>
                                            </li>
                                            <!-- quality modes menu -->
                                            <li
                                                class="group/menu-item relative animate-fade-in"
                                                (click)="
                                                    onQualityModesClicked()
                                                "
                                                style="animation-delay: 0ms"
                                                [class.disabled-link]="true"
                                                [class.active]="
                                                    qualityModes == true ||
                                                    router.url.includes(
                                                        'quality-mode'
                                                    )
                                                "
                                            >
                                                <a
                                                    routerLink="/components/quality-mode"
                                                    routerLinkActive="active"
                                                    [ngClass]="
                                                        qualityModes === true ||
                                                        router.url.includes(
                                                            'quality-mode'
                                                        )
                                                            ? [
                                                                  'transform',
                                                                  'scale-[1.02]',
                                                                  'bg-gradient-to-r',
                                                                  'from-blue-600',
                                                                  'to-blue-500',
                                                                  '!text-white',
                                                                  'ring-2',
                                                                  'ring-blue-400/30',
                                                                  'shadow-lg',
                                                              ]
                                                            : [
                                                                  'hover:bg-gradient-to-r',
                                                                  'hover:from-blue-50',
                                                                  'hover:to-blue-50/50',
                                                                  'hover:!text-blue-700',
                                                                  'hover:shadow-md',
                                                                  'hover:scale-[1.01]',
                                                                  'hover:translate-x-[4px]',
                                                              ]
                                                    "
                                                    class="peer/menu-button group flex w-full items-center gap-[12px] px-[16px] py-[14px] rounded-xl text-sm font-medium transition-all duration-300 min-h-[48px] relative overflow-hidden text-sidebar-foreground !text-gray-900"
                                                >
                                                    <div
                                                        class="flex items-center justify-center w-[24px] h-[24px] rounded-lg transition-all duration-300 relative z-10"
                                                        [matTooltip]="
                                                            isCollapsed
                                                                ? ('navigation.quality-modes'
                                                                  | translate)
                                                                : ''
                                                        "
                                                        matTooltipPosition="right"
                                                        [ngClass]="
                                                            qualityModes ===
                                                                true ||
                                                            router.url.includes(
                                                                'quality-mode'
                                                            )
                                                                ? [
                                                                      'text-white',
                                                                      'bg-white/20',
                                                                  ]
                                                                : [
                                                                      'text-muted-foreground',
                                                                      'group-hover:text-blue-700',
                                                                      'group-hover:bg-blue-100',
                                                                      'group-hover:scale-110',
                                                                  ]
                                                        "
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            stroke-width="2"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            class="lucide lucide-users-round w-4 h-4"
                                                        >
                                                            <path
                                                                d="M18 21a8 8 0 0 0-16 0"
                                                            ></path>
                                                            <circle
                                                                cx="10"
                                                                cy="8"
                                                                r="5"
                                                            ></circle>
                                                            <path
                                                                d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <span
                                                        *ngIf="!isCollapsed"
                                                        class="flex-1 text-left leading-tight relative z-10 font-medium"
                                                        [ngClass]="
                                                            qualityModes ===
                                                                true ||
                                                            router.url.includes(
                                                                'quality-mode'
                                                            )
                                                                ? ['text-white']
                                                                : [
                                                                      'text-gray-900',
                                                                  ]
                                                        "
                                                    >
                                                        {{
                                                            "navigation.quality-modes"
                                                                | translate
                                                        }}
                                                    </span>
                                                    <!-- <span *ngIf="!isCollapsed"
                                                    class="bg-blue-100 text-blue-700 px-2 py-1.0 rounded">
                                                    Coming Soon
                                                </span> -->
                                                    <div
                                                        *ngIf="!isCollapsed"
                                                        class="text-[11px] font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded-full"
                                                    >
                                                        {{
                                                            "profile.coming-soon"
                                                                | translate
                                                        }}
                                                    </div>
                                                    <div
                                                        class="absolute inset-0 bg-gradient-to-r from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                                    ></div>
                                                </a>
                                            </li>
                                            <!-- messages menu -->
                                            <li
                                                class="group/menu-item relative animate-fade-in"
                                                (click)="onMessagesClicked()"
                                                style="animation-delay: 50ms"
                                                [class.disabled-link]="true"
                                                [class.active]="
                                                    messages == true ||
                                                    router.url.includes(
                                                        'messages'
                                                    )
                                                "
                                            >
                                                <a
                                                    routerLink="/components/messages"
                                                    routerLinkActive="active"
                                                    [ngClass]="
                                                        messages === true ||
                                                        router.url.includes(
                                                            'messages'
                                                        )
                                                            ? [
                                                                  'transform',
                                                                  'scale-[1.02]',
                                                                  'bg-gradient-to-r',
                                                                  'from-blue-600',
                                                                  'to-blue-500',
                                                                  '!text-white',
                                                                  'ring-2',
                                                                  'ring-blue-400/30',
                                                                  'shadow-lg',
                                                              ]
                                                            : [
                                                                  'hover:bg-gradient-to-r',
                                                                  'hover:from-blue-50',
                                                                  'hover:to-blue-50/50',
                                                                  'hover:!text-blue-700',
                                                                  'hover:shadow-md',
                                                                  'hover:scale-[1.01]',
                                                                  'hover:translate-x-[4px]',
                                                              ]
                                                    "
                                                    class="peer/menu-button group flex w-full items-center gap-[12px] px-[16px] py-[14px] rounded-xl text-sm font-medium transition-all duration-300 min-h-[48px] relative overflow-hidden text-sidebar-foreground !text-gray-900"
                                                >
                                                    <div
                                                        class="flex items-center justify-center w-[24px] h-[24px] rounded-lg transition-all duration-300 relative z-10"
                                                        [matTooltip]="
                                                            isCollapsed
                                                                ? ('navigation.manage-routines'
                                                                  | translate)
                                                                : ''
                                                        "
                                                        matTooltipPosition="right"
                                                        [ngClass]="
                                                            messages === true ||
                                                            router.url.includes(
                                                                'messages'
                                                            )
                                                                ? [
                                                                      'text-white',
                                                                      'bg-white/20',
                                                                  ]
                                                                : [
                                                                      'text-muted-foreground',
                                                                      'group-hover:text-blue-700',
                                                                      'group-hover:bg-blue-100',
                                                                      'group-hover:scale-110',
                                                                  ]
                                                        "
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            stroke-width="2"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            class="lucide lucide-clipboard-list w-4 h-4"
                                                        >
                                                            <rect
                                                                width="8"
                                                                height="4"
                                                                x="8"
                                                                y="2"
                                                                rx="1"
                                                                ry="1"
                                                            ></rect>
                                                            <path
                                                                d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                                                            ></path>
                                                            <path
                                                                d="M12 11h4"
                                                            ></path>
                                                            <path
                                                                d="M12 16h4"
                                                            ></path>
                                                            <path
                                                                d="M8 11h.01"
                                                            ></path>
                                                            <path
                                                                d="M8 16h.01"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <span
                                                        *ngIf="!isCollapsed"
                                                        class="flex-1 text-left leading-tight relative z-10 font-medium"
                                                        [ngClass]="
                                                            messages === true ||
                                                            router.url.includes(
                                                                'messages'
                                                            )
                                                                ? ['text-white']
                                                                : [
                                                                      'text-gray-900',
                                                                  ]
                                                        "
                                                    >
                                                        {{
                                                            "navigation.manage-routines"
                                                                | translate
                                                        }}
                                                    </span>
                                                    <!-- <span *ngIf="!isCollapsed"
                                                    class="bg-blue-100 text-blue-700 px-2 py-1.0 rounded">
                                                    Coming Soon
                                                </span> -->
                                                    <div
                                                        *ngIf="!isCollapsed"
                                                        class="text-[11px] font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded-full"
                                                    >
                                                        {{
                                                            "profile.coming-soon"
                                                                | translate
                                                        }}
                                                    </div>
                                                    <div
                                                        class="inline-flex items-center justify-center min-w-[24px] h-[24px] px-[8px] rounded-full text-[11px] font-bold transition-all duration-300 shadow-md relative z-10 animate-pulse bg-white text-blue-600 shadow-lg scale-110"
                                                        [ngClass]="
                                                            messages === true ||
                                                            router.url.includes(
                                                                'messages'
                                                            )
                                                                ? [
                                                                      'bg-white',
                                                                      'text-blue-600',
                                                                      'shadow-lg',
                                                                      'scale-110',
                                                                  ]
                                                                : [
                                                                      'animate-pulse',
                                                                      'bg-gradient-to-r',
                                                                      'from-blue-600',
                                                                      'to-blue-500',
                                                                      'text-white',
                                                                  ]
                                                        "
                                                        *ngIf="
                                                            (messagesCount$
                                                                | async) > 0
                                                        "
                                                    >
                                                        {{
                                                            messagesCount$
                                                                | async
                                                        }}
                                                    </div>
                                                    <div
                                                        class="absolute inset-0 bg-gradient-to-r from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                                    ></div>
                                                </a>
                                            </li>
                                        </ul>
                                        <!-- Quick Actions -->
                                        <div
                                            *ngIf="
                                                customer?.employeeRole?.id != 3
                                            "
                                            class="px-[7px] py-[12px] border-t border-[rgb(229,231,235)] bg-sidebar/50 relative overflow-hidden"
                                        >
                                            <div
                                                class="absolute inset-0 bg-gradient-to-t from-primary/5 to-transparent opacity-60"
                                            ></div>

                                            <div
                                                class="flex w-full min-w-0 flex-col relative z-10 mb-3"
                                                *ngIf="customer"
                                            >
                                                <div
                                                    *ngIf="!isCollapsed"
                                                    class="duration-200 flex h-[32px] shrink-0 items-center rounded-[6px] outline-none ring-sidebar-ring transition-[margin,opa] ease-linear focus-visible:ring-2 [&>svg]:size-[16px] [&>svg]:shrink-0 group-data-[collapsible=icon]:-mt-[32px] group-data-[collapsible=icon]:opacity-0 text-[11px] font-bold text-primary/80 uppercase tracking-widest mb-[16px] opacity-90"
                                                >
                                                    {{
                                                        "navigation.quick-actions"
                                                            | translate
                                                    }}
                                                </div>

                                                <div
                                                    class="w-full text-sm space-y-[12px] flex flex-col gap-[10px] quick-actions-container"
                                                >
                                                    <!-- First Button -->
                                                    <button
                                                        *ngIf="this?.customer"
                                                        routerLink="/components/assignments/create-assignment/step1"
                                                        (click)="
                                                            onCreateAssignment()
                                                        "
                                                        class="inline-flex items-center whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-[16px] [&_svg]:shrink-0 hover:bg-primary/90 !rounded-[6px] px-[12px] w-full justify-start gap-[12px] h-[48px] text-sm font-bold bg-gradient-to-r from-blue-600 via-blue-600/95 to-blue-500 hover:from-blue-700 hover:via-blue-700/95 hover:to-blue-600 text-white shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-[1.03] group relative overflow-hidden border-0 ring-2 ring-blue-400/30 hover:ring-blue-400/50"
                                                        aria-label="Create Assignment"
                                                    >
                                                        <div
                                                            class="absolute inset-0 bg-gradient-to-r from-white/10 via-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                                        ></div>
                                                        <div
                                                            [matTooltip]="
                                                                isCollapsed
                                                                    ? ('navigation.book-security-services'
                                                                      | translate)
                                                                    : ''
                                                            "
                                                            matTooltipPosition="right"
                                                            class="flex items-center justify-center w-[24px] h-[24px] bg-white/25 rounded-lg group-hover:bg-white/35 transition-all duration-300 group-hover:scale-110 shadow-sm relative z-10"
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                class="lucide lucide-plus h-[16px] w-[16px] font-bold"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor"
                                                                stroke-width="2"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                            >
                                                                <path
                                                                    d="M5 12h14"
                                                                ></path>
                                                                <path
                                                                    d="M12 5v14"
                                                                ></path>
                                                            </svg>
                                                        </div>
                                                        <span
                                                            *ngIf="!isCollapsed"
                                                            class="relative z-10 tracking-wide"
                                                            >{{
                                                                "navigation.book-security-services"
                                                                    | translate
                                                            }}</span
                                                        >
                                                        <div
                                                            class="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                                        ></div>
                                                    </button>

                                                    <!-- Second Button -->
                                                    <button
                                                        *ngIf="
                                                            this?.customer &&
                                                            customer
                                                                ?.employeeRole
                                                                ?.id !=
                                                                employeeRole?.USER
                                                        "
                                                        (click)="
                                                            onInviteCoworkers()
                                                        "
                                                        class="inline-flex items-center whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-[16px] [&_svg]:shrink-0 border !rounded-[6px] px-[12px] w-full justify-start gap-[12px] h-[44px] text-sm font-semibold border-blue-200/50 bg-blue-50/70 hover:bg-blue-100 text-blue-700 hover:text-blue-800 hover:border-blue-300 transition-all duration-300 hover:scale-[1.02] hover:shadow-lg group backdrop-blur-sm relative overflow-hidden"
                                                    >
                                                        <div
                                                            class="absolute inset-0 bg-gradient-to-r from-blue-100/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                                        ></div>
                                                        <div
                                                            [matTooltip]="
                                                                isCollapsed
                                                                    ? ('navigation.invite'
                                                                      | translate)
                                                                    : ''
                                                            "
                                                            matTooltipPosition="right"
                                                            class="flex items-center justify-center w-[20px] h-[20px] rounded-[6px] bg-blue-100 group-hover:bg-blue-200 transition-all duration-300 relative z-10"
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                class="lucide lucide-users-round h-[16px] w-[16px] text-blue-600"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor"
                                                                stroke-width="2"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                            >
                                                                <path
                                                                    d="M18 21a8 8 0 0 0-16 0"
                                                                ></path>
                                                                <circle
                                                                    cx="10"
                                                                    cy="8"
                                                                    r="5"
                                                                ></circle>
                                                                <path
                                                                    d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"
                                                                ></path>
                                                            </svg>
                                                        </div>
                                                        <span
                                                            *ngIf="!isCollapsed"
                                                            class="relative z-10"
                                                            >{{
                                                                "navigation.invite"
                                                                    | translate
                                                            }}</span
                                                        >
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    *ngIf="customer"
                    class="bottom-nav fixed bottom-0 sm:relative w-full bg-white z-10"
                >
                    <!-- Company -->
                    <div
                        *ngIf="customer"
                        [matTooltip]="
                            isCollapsed
                                ? ('navigation.company-settings' | translate)
                                : ''
                        "
                        matTooltipPosition="right"
                    >
                        <div
                            [ngClass]="
                                router.url === '/components/company/users'
                                    ? [
                                          'transform',
                                          'scale-[1.02]',
                                          'bg-gradient-to-r',
                                          'from-blue-600',
                                          'to-blue-500',
                                          '!text-white',
                                          'ring-2',
                                          'ring-blue-400/30',
                                          'shadow-lg',
                                      ]
                                    : [
                                          'hover:bg-gradient-to-r',
                                          'hover:from-blue-50',
                                          'hover:to-blue-50/50',
                                          'hover:!text-blue-700',
                                          'hover:shadow-md',
                                          'hover:scale-[1.01]',
                                          'hover:translate-x-[4px]',
                                      ]
                            "
                            class="flex w-full whitespace-nowrap focus-visible:outline-none ring-offset-background items-center gap-[12px] px-[16px] py-[8px] !rounded-xl text-sm font-medium transition-all duration-300 min-h-[48px] relative overflow-hidden text-sidebar-foreground !text-gray-900 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 justify-between"
                            aria-label="Company settings"
                        >
                            <button
                                class="flex items-center gap-[12px]"
                                (click)="onCompanyNameClicked($event)"
                            >
                                <!-- ICON -->
                                <div
                                    class="flex items-center justify-center w-[24px] h-[25px] !rounded-lg transition-all duration-300 relative z-10"
                                    [ngClass]="
                                        router.url ===
                                        '/components/company/users'
                                            ? ['text-white', 'bg-white/20']
                                            : [
                                                  'text-muted-foreground',
                                                  'group-hover:text-blue-700',
                                                  'group-hover:bg-blue-100',
                                                  'group-hover:scale-110',
                                              ]
                                    "
                                >
                                    <img
                                        *ngIf="customer?.image; else noLogo"
                                        [src]="customer?.image"
                                        alt="Company"
                                        (error)="onImageError($event)"
                                        loading="lazy"
                                        class="h-[26px] w-[26px] rounded object-cover transition-transform duration-300 group-hover:scale-110"
                                    />
                                    <ng-template #noLogo>
                                        <img
                                            src="../../assets/img/safetly_logo_re.png"
                                            alt="Safetly"
                                            class="h-[26px] w-[26px] rounded object-cover transition-transform duration-300 group-hover:scale-110"
                                            loading="lazy"
                                        />
                                    </ng-template>
                                    <div
                                        class="absolute inset-0 bg-gradient-to-tr from-white/10 to-transparent rounded-[8px] opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                    ></div>
                                </div>

                                <!-- TEXT -->
                                <div
                                    *ngIf="!isCollapsed"
                                    class="flex-1 text-left transition-all duration-300 group-hover:translate-x-[2px]"
                                    [ngClass]="
                                        router.url ===
                                        '/components/company/users'
                                            ? ['text-white']
                                            : ['text-gray-900']
                                    "
                                >
                                    <div
                                        class="font-semibold text-sm leading-tight"
                                    >
                                        {{
                                            "navigation.company-settings"
                                                | translate
                                        }}
                                    </div>
                                    <div
                                        class="text-[12px] text-muted-foreground font-medium mt-[2px] break-words whitespace-normal"
                                        *ngIf="customer; else noCustomer"
                                    >
                                        {{ customer?.companyName | titlecase }}
                                    </div>
                                </div>
                            </button>

                            <!-- SWITCH ICON -->
                            <button
                                style="height: 34px; width: 34px"
                                (click)="
                                    switchCompany(); $event.stopPropagation()
                                "
                            >
                                <img
                                    *ngIf="
                                        customers?.length > 1 && !isCollapsed
                                    "
                                    class="switch-icon-small"
                                    [class.rotate]="switchAccountOptions"
                                    loading="lazy"
                                    [src]="
                                        router.url ===
                                        '/components/company/users'
                                            ? '../../assets/img/switch-white.svg'
                                            : '../../assets/img/switch-black.svg'
                                    "
                                    alt="switch"
                                />
                            </button>
                        </div>

                        <ng-template #noCustomer>
                            <p class="company-title">
                                {{
                                    "navigation.no-companies-to-select"
                                        | translate
                                }}
                            </p>
                        </ng-template>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-template #aiSidebar>
            <div class="ai-sidebar">
                <div class="ai-sidebar-header">
                    <div
                        class="ai-brand"
                        routerLink="!customer ? '/' : '/components/assignments'"
                    >
                        <div class="ai-logo-wrap">
                            <img
                                src="/assets/img/safetly_logo_re.png"
                                loading="lazy"
                                alt="Safetly logo"
                                class="ai-logo"
                            />
                        </div>
                        <div class="ai-brand-text">
                            <div class="ai-title">
                                {{ "ai.title" | translate }}
                            </div>
                            <div class="ai-status">
                                <span class="ai-status-dot"></span>
                                <span>{{ "ai.online" | translate }}</span>
                            </div>
                        </div>
                    </div>
                    <mat-icon
                        *ngIf="closeIcon"
                        (click)="opened = false"
                        class="close-icon"
                        >close</mat-icon
                    >
                </div>

                <div class="ai-sidebar-body">
                    <div #aiScrollContent class="ai-scrollable-content">
                        <div class="ai-chat-card">
                            <div
                                *ngFor="let item of aiConversation"
                                class="ai-bubble-wrap"
                                [ngClass]="
                                    item.role === 'assistant'
                                        ? 'assistant'
                                        : 'user'
                                "
                            >
                                <div
                                    class="ai-bubble"
                                    [ngClass]="
                                        item.role === 'assistant'
                                            ? 'assistant'
                                            : 'user'
                                    "
                                    [class.ai-bubble-thinking]="
                                        item.role === 'assistant' &&
                                        item.thinkingState
                                    "
                                >
                                    <span *ngIf="item.role === 'user'">{{
                                        item.messageKey
                                            ? (item.messageKey | translate)
                                            : item.message
                                    }}</span>
                                    <ng-container
                                        *ngIf="item.role === 'assistant'"
                                    >
                                        <div
                                            *ngIf="item.thinkingState"
                                            class="ai-thinking-row"
                                        >
                                            <span class="ai-thinking-dots">{{
                                                (item.thinkingState ===
                                                "generating"
                                                    ? "ai.generating"
                                                    : "ai.thinking"
                                                ) | translate
                                            }}</span>
                                        </div>
                                        <markdown
                                            *ngIf="!item.thinkingState"
                                            class="ai-bubble-content"
                                            [data]="
                                                getAssistantMessageContent(item)
                                            "
                                        ></markdown>
                                    </ng-container>
                                </div>
                                <span
                                    *ngIf="item.sentAt"
                                    class="ai-bubble-time"
                                    >{{ item.sentAt | date: "HH:mm" }}</span
                                >
                            </div>
                        </div>
                    </div>

                    <div class="ai-sticky-content">
                        <div *ngIf="!customer" class="ai-login-wrap">
                            <a routerLink="/login" class="ai-login-btn">
                                <span>{{ "buttons.login" | translate }}</span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                >
                                    <path d="M5 12h14"></path>
                                    <path d="m12 5 7 7-7 7"></path>
                                </svg>
                            </a>
                        </div>

                        <div
                            class="ai-suggestions"
                            *ngIf="currentAiSuggestions.length"
                        >
                            <div class="ai-suggestions-title">
                                {{ "ai.suggestions-title" | translate }}
                            </div>
                            <button
                                *ngFor="let suggestion of currentAiSuggestions"
                                type="button"
                                class="ai-suggestion-btn"
                                (click)="useSuggestion(suggestion)"
                                [disabled]="aiSuggestionsRefreshing"
                            >
                                {{ getSuggestionLabel(suggestion) }}
                            </button>
                        </div>

                        <div *ngIf="aiError" class="ai-error-message">
                            {{ aiError }}
                        </div>
                        <div class="ai-sidebar-footer">
                            <div class="ai-input-wrap">
                                <textarea
                                    class="ai-input-textarea"
                                    rows="1"
                                    [(ngModel)]="aiInput"
                                    [placeholder]="'ai.placeholder' | translate"
                                    (keydown.enter)="sendAiMessage($event)"
                                    [disabled]="aiSending"
                                    aria-label="Type your question"
                                ></textarea>
                                <button
                                    type="button"
                                    class="ai-send-btn"
                                    (click)="sendAiMessage()"
                                    [disabled]="aiSending"
                                    aria-label="Send message"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    >
                                        <path d="M22 2 11 13"></path>
                                        <path
                                            d="M22 2 15 22 11 13 2 9 22 2z"
                                        ></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </mat-sidenav>
    <mat-sidenav-content (scroll)="onMainScroll($event)">
        <!-- ── Top Navigation Header (logged-in users) ── -->
        <header *ngIf="customer && showSidebar" class="top-header">
            <!-- Left: breadcrumb -->
            <div class="top-header-left">
                <button
                    *ngIf="!navButton && isCollapsed"
                    class="top-header-sidebar-toggle"
                    (click)="toggleSidebar()"
                    aria-label="Expand sidebar"
                >
                    <img
                        loading="lazy"
                        src="../../assets/svg/sidebar-out.svg"
                        alt="expand sidebar"
                    />
                </button>
                <!-- <span class="top-header-breadcrumb">
                    <span class="breadcrumb-root">{{ 'navigation.all-projects' | translate }}</span>
                    <span class="breadcrumb-sep">/</span>
                    <span class="breadcrumb-current">{{ customer?.companyName | titlecase }}</span>
                </span> -->
            </div>

            <!-- Right: actions -->
            <div class="top-header-right">
                <!-- Language switcher -->
                <div
                    class="top-header-lang"
                    (clickOutside)="languageDropdownOpen = false"
                >
                    <button
                        type="button"
                        class="top-header-lang-btn"
                        (click)="
                            toggleLanguageDropdown(); $event.stopPropagation()
                        "
                        [attr.aria-expanded]="languageDropdownOpen"
                        aria-label="Select language"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <circle cx="12" cy="12" r="10"></circle>
                            <path
                                d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                            ></path>
                            <path d="M2 12h20"></path>
                        </svg>
                        <span>{{ currentLangCode }}</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            [class.rotate-180]="languageDropdownOpen"
                        >
                            <path d="m6 9 6 6 6-6"></path>
                        </svg>
                    </button>
                    <div
                        *ngIf="languageDropdownOpen"
                        class="top-header-lang-dropdown"
                    >
                        <button
                            type="button"
                            (click)="setLanguage('sv', $event)"
                            [class.active]="(currentLang || 'sv') === 'sv'"
                        >
                            Svenska
                        </button>
                        <button
                            type="button"
                            (click)="setLanguage('en', $event)"
                            [class.active]="(currentLang || 'sv') === 'en'"
                        >
                            English
                        </button>
                    </div>
                </div>

                <!-- Company switcher -->
                <div
                    class="top-header-company"
                    (clickOutside)="closeHeaderDropdown()"
                >
                    <button
                        type="button"
                        class="top-header-company-btn"
                        (click)="openHeaderDropdown(); $event.stopPropagation()"
                        aria-label="Switch company"
                    >
                        <img
                            *ngIf="customer?.image; else headerNoLogo"
                            [src]="customer?.image"
                            alt="Company logo"
                            (error)="onImageError($event)"
                            loading="lazy"
                            class="top-header-company-logo"
                        />
                        <ng-template #headerNoLogo>
                            <img
                                src="../../assets/img/safetly_logo_re.png"
                                alt="Safetly"
                                loading="lazy"
                                class="top-header-company-logo"
                            />
                        </ng-template>
                        <span class="top-header-company-name">{{
                            customer?.companyName | titlecase
                        }}</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            [class.rotate-180]="headerCompanyDropdownOpen"
                        >
                            <path d="m6 9 6 6 6-6"></path>
                        </svg>
                    </button>

                    <!-- Company dropdown -->
                    <div
                        *ngIf="headerCompanyDropdownOpen"
                        class="top-header-company-dropdown"
                        (click)="$event.stopPropagation()"
                    >
                        <!-- Search (shown when > 4 companies) -->
                        <div
                            *ngIf="customers?.length > 4"
                            class="top-header-company-search"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="search-icon"
                            >
                                <circle cx="11" cy="11" r="8"></circle>
                                <path d="m21 21-4.3-4.3"></path>
                            </svg>
                            <input
                                type="text"
                                #headerCompanySearchInput
                                class="top-header-company-search-input"
                                [value]="headerSearchTerm"
                                appAutofocus
                                (input)="
                                    onHeaderSearchChange(
                                        $any($event.target).value
                                    )
                                "
                                [placeholder]="
                                    'navigation.search_customer' | translate
                                "
                                (click)="$event.stopPropagation()"
                            />
                            <button
                                *ngIf="headerSearchTerm"
                                type="button"
                                class="search-clear-btn"
                                (click)="
                                    clearHeaderSearch();
                                    $event.stopPropagation()
                                "
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="13"
                                    height="13"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                >
                                    <path d="M18 6 6 18"></path>
                                    <path d="m6 6 12 12"></path>
                                </svg>
                            </button>
                        </div>
                        <div
                            *ngIf="customers?.length > 4"
                            class="top-header-company-divider"
                        ></div>

                        <!-- Company list -->
                        <div class="top-header-company-list">
                            <ng-container
                                *ngIf="
                                    headerFilteredCustomers?.length > 0;
                                    else headerNoResults
                                "
                            >
                                <div
                                    *ngFor="let c of headerFilteredCustomers"
                                    class="top-header-company-item"
                                    [class.active]="isCurrentCompany(c)"
                                    (click)="
                                        !isCurrentCompany(c) &&
                                            onSwitchCustomer(c);
                                        closeHeaderDropdown()
                                    "
                                >
                                    <span>{{
                                        c?.companyName | titlecase
                                    }}</span>
                                    <svg
                                        *ngIf="isCurrentCompany(c)"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    >
                                        <path d="M20 6 9 17l-5-5"></path>
                                    </svg>
                                </div>
                            </ng-container>
                            <ng-template #headerNoResults>
                                <div class="top-header-company-no-results">
                                    {{
                                        "navigation.search_not_found"
                                            | translate
                                    }}
                                </div>
                            </ng-template>
                        </div>

                        <div class="top-header-company-divider"></div>
                        <div
                            class="top-header-company-item settings-item"
                            (click)="
                                router.navigate(['/components/company/users']);
                                closeHeaderDropdown()
                            "
                        >
                            <span>{{ "navigation.settings" | translate }}</span>
                        </div>
                    </div>
                </div>

                <!-- Invite button -->
                <button
                    *ngIf="
                        this?.customer &&
                        customer?.employeeRole?.id != employeeRole?.USER
                    "
                    (click)="onInviteCoworkers()"
                    class="top-header-invite-btn inline-flex items-center whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-[16px] [&_svg]:shrink-0 !rounded-[6px] px-[12px] justify-center gap-[8px] h-[34px] text-sm font-semibold border-blue-200/50 bg-blue-50/70 hover:bg-blue-100 text-blue-700 hover:text-blue-800 hover:border-blue-300 transition-all duration-300 hover:scale-[1.02] hover:shadow-lg group backdrop-blur-sm relative overflow-hidden"
                >
                    <div
                        class="absolute inset-0 bg-gradient-to-r from-blue-100/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    ></div>
                    <div
                        [matTooltip]="
                            isCollapsed ? ('navigation.invite' | translate) : ''
                        "
                        matTooltipPosition="right"
                        class="flex items-center justify-center w-[20px] h-[20px] rounded-[6px] bg-blue-100 group-hover:bg-blue-200 transition-all duration-300 relative z-10"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="lucide lucide-users-round h-[16px] w-[16px] text-blue-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path d="M18 21a8 8 0 0 0-16 0"></path>
                            <circle cx="10" cy="8" r="5"></circle>
                            <path
                                d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"
                            ></path>
                        </svg>
                    </div>
                    <span
                        *ngIf="!isCollapsed"
                        class="top-header-invite-text relative z-10"
                        >{{ "navigation.invite" | translate }}</span
                    >
                </button>

                <!-- Create booking button -->
                <button
                    *ngIf="customer?.employeeRole?.id != 3"
                    type="button"
                    class="top-header-create-btn"
                    routerLink="/components/assignments/create-assignment/step1"
                    (click)="onCreateAssignment()"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path d="M5 12h14"></path>
                        <path d="M12 5v14"></path>
                    </svg>
                    <span>{{ "navigation.create-booking" | translate }}</span>
                </button>

                <!-- Logout button -->
                <button
                    type="button"
                    class="top-header-logout-btn"
                    (click)="onLogout()"
                    [matTooltip]="'navigation.logout' | translate"
                    matTooltipPosition="below"
                    aria-label="Log out"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path
                            d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
                        ></path>
                        <polyline points="16 17 21 12 16 7"></polyline>
                        <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                </button>
            </div>
        </header>

        <!-- Guest: language switcher only -->
        <div
            *ngIf="!customer"
            class="flex items-center gap-3 language-switcher"
        >
            <button
                *ngIf="!navButton && showSidebar && isCollapsed"
                class="menu-button-open"
                (click)="toggleSidebar()"
                aria-label="Toggle Collapse"
            >
                <img
                    [class.rotate]="switchAccountOptions"
                    loading="lazy"
                    src="../../assets/svg/sidebar-out.svg"
                    alt="sidebar-out"
                />
            </button>
            <div
                class="language-switcher-wrapper flex-shrink-0"
                (clickOutside)="languageDropdownOpen = false"
            >
                <button
                    type="button"
                    class="language-switcher-btn"
                    (click)="toggleLanguageDropdown(); $event.stopPropagation()"
                    [attr.aria-expanded]="languageDropdownOpen"
                    aria-label="Select language"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="language-globe-icon"
                    >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path
                            d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                        ></path>
                        <path d="M2 12h20"></path>
                    </svg>
                    <span class="language-code">{{ currentLangCode }}</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="language-chevron"
                        [class.rotate-180]="languageDropdownOpen"
                    >
                        <path d="m6 9 6 6 6-6"></path>
                    </svg>
                </button>
                <div *ngIf="languageDropdownOpen" class="language-dropdown">
                    <button
                        type="button"
                        class="language-option"
                        (click)="setLanguageForGuest('sv', $event)"
                        [class.active]="(currentLang || 'sv') === 'sv'"
                    >
                        Svenska
                    </button>
                    <button
                        type="button"
                        class="language-option"
                        (click)="setLanguageForGuest('en', $event)"
                        [class.active]="(currentLang || 'sv') === 'en'"
                    >
                        English
                    </button>
                </div>
            </div>
        </div>

        <hr
            *ngIf="!navButton && showSidebar && isCollapsed && !customer"
            class="menu-button-open-line"
        />

        <app-progress-bar-request></app-progress-bar-request>
        <button
            *ngIf="
                showSidebar &&
                navButton &&
                (!customer || (customer && this?.customers?.length > 0))
            "
            class="navigation-button justify-content-center"
            [class.hidden]="!showNavigationButton"
            (click)="onSwitchAccountClicked()"
            aria-label="Switch Account"
        >
            <img
                [class.rotate]="switchAccountOptions"
                loading="lazy"
                src="../../assets/img/menu.svg"
                alt="menu"
            />
        </button>

        <!-- Scroll to Top Button - Mobile Only -->
        <button
            *ngIf="showScrollToTop"
            class="scroll-to-top-button"
            (click)="scrollToTop()"
            [matTooltip]="'navigation.scroll-to-top' | translate"
            matTooltipPosition="left"
            aria-label="Scroll to Top"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <path d="m18 15-6-6-6 6" />
            </svg>
        </button>

        <router-outlet></router-outlet>

        <!-- Switch account options -->
        <div
            *ngIf="switchAccountOptions"
            class="switch-account-options"
            (clickOutside)="switchAccountOptions = false"
        >
            <ng-container
                *ngIf="this?.customers?.length > 0; else noCustomers"
                class="wrapper"
            >
                <div class="title">
                    <p class="bold">{{ "navigation.switch" | translate }}</p>
                </div>
                <div class="line"></div>
                <!-- Search customer -->
                <!-- <div class="search-customer" *ngIf="customers?.length > 4">
                    <input type="text" class="form-control placeholder:text-sm"
                        [formControl]="searchForm.get('searchCustomer')"
                        [placeholder]="'navigation.search_customer' | translate">
                </div>
                <button (click)="clearCompany()"
                    class="mobile-touch-target flex items-center justify-center text-gray-400 hover:text-gray-600 touch-feedback p-[8px]">
                    <svg class="lucide lucide-x" fill="none" height="20" stroke="currentColor" stroke-linecap="round"
                        stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6 6 18"></path>
                        <path d="m6 6 12 12"></path>
                    </svg>
                </button> -->
                <!-- Search customer -->
                <div
                    class="search-customer relative"
                    *ngIf="customers?.length > 4"
                >
                    <input
                        type="text"
                        class="form-control placeholder:text-sm pr-8 w-full"
                        [formControl]="searchForm.get('searchCustomer')"
                        [placeholder]="'navigation.search_customer' | translate"
                    />

                    <!-- Clear icon (visible only when there's text) -->
                    <button
                        *ngIf="searchForm.get('searchCustomer')?.value"
                        type="button"
                        class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                        (click)="clearSearch()"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="lucide lucide-x"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            stroke-width="2"
                            width="18"
                            height="18"
                        >
                            <path d="M18 6 6 18"></path>
                            <path d="m6 6 12 12"></path>
                        </svg>
                    </button>
                </div>

                <div class="line"></div>
                <!-- Customers -->
                <div *ngIf="filteredCustomers?.length > 0; else noResults">
                    <div
                        class="d-flex justify-content-between item"
                        *ngFor="let customer of filteredCustomers"
                        (click)="
                            !isCurrentCompany(customer) &&
                                onSwitchCustomer(customer)
                        "
                        [ngClass]="{
                            'disabled-company': isCurrentCompany(customer),
                        }"
                    >
                        <p class="mt-auto mb-auto">
                            {{ customer?.companyName | titlecase }}
                        </p>
                        <img
                            class="mt-auto mb-auto"
                            [src]="
                                isCurrentCompany(customer)
                                    ? '/assets/img/checked.svg'
                                    : '/assets/img/Arrow-right.svg'
                            "
                            loading="lazy"
                            [alt]="
                                isCurrentCompany(customer)
                                    ? 'Selected'
                                    : 'Select'
                            "
                        />
                    </div>
                </div>

                <!-- Message when no results -->
                <ng-template #noResults>
                    <div class="text-center text-muted mt-3 font-bold">
                        {{ "navigation.search_not_found" | translate }}
                    </div>
                </ng-template>
            </ng-container>
            <ng-template #noCustomers>
                <div class="title">
                    <p class="bold">
                        {{ "navigation.no-companies-to-select" | translate }}
                    </p>
                </div>
            </ng-template>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>